var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("progress", {
        staticClass: "progress is-medium",
        class: _vm.getPercentageColor,
        attrs: { max: "100" },
        domProps: { value: _vm.getPercentageValue },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "has-text-centered" },
        [
          _c(
            "b-tooltip",
            {
              attrs: {
                multilined: "",
                size: "is-large",
                label:
                  _vm.Constants.STRINGS.TOOLTIPS.INFORMATION_OTRO_DOCUMENTO
                    .SIGNS_PROGRESS,
              },
            },
            [
              _c("i", { staticClass: "fas fa-tachometer-alt fa-fw" }),
              _vm._v(
                " Progreso - " +
                  _vm._s(this.getActualSignsInSignedStateLength) +
                  " de " +
                  _vm._s(this.getAllSignsLength) +
                  " firma" +
                  _vm._s(this.getAllSignsLength > 1 ? "s" : "") +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.tableData,
            bordered: false,
            loading: false,
            narrowed: "",
            hoverable: "",
            "mobile-cards": "",
          },
        },
        [
          _c("b-table-column", {
            attrs: { label: "Nombre y Apellido" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-user fa-fw" }),
                      _vm._v(" " + _vm._s(props.row.usuario) + " "),
                      props.row.pendiente
                        ? _c("i", { staticClass: "fas fa-arrow-left fa-fw" })
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Estado de firmas", centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("b-icon", {
                      attrs: { pack: "fas", icon: props.row.icon },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Fecha y hora de firma", centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    props.row.signed_at
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                new Date(props.row.signed_at),
                                "dddd, DD/MM/YYYY, HH:mm:ss"
                              )
                            )
                          ),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5" }, [
      _c("i", { staticClass: "fas fa-sitemap fa-fw" }),
      _vm._v(" Circuito de firmas"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }